<template>
  <div id="app">
<!--    <div ref="process" style='border-top: 3px solid #3a8ee6;'></div>-->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
  },
  mounted() {
  },
  data(){
    return{
      processWith:0
    }
  },
  methods:{
    // process(){
    //   let that=this
    //   console.log(that.processWith)
    //   setTimeout(res=>{
    //     if(that.processWith<100){
    //       that.processWith+=0.1;
    //       that.$refs.process.style.width=that.processWith+"%"
    //       that.process()
    //     }else{
    //       that.$refs.process.style.visibility="hidden"
    //     }
    //   },10)
    // }
  }
}
</script>

<style lang="scss">
@import '../src/assets/fonts/font.css';

html,
body {
  width: 100%;
  height: 100% !important;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-family: PingFang;
}
#app {
  padding: 0;
  margin: 0;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue